<app-container-transparent>

    <div flexLayout="row" style="margin-bottom: 20px;">
        <div fxFlex="60"></div>
        <div fxFlex="40" style="padding: 0;"> <!-- routerLink="/mfg" -->
            <div class="test">
                <button (click)="clickNavigation('/favorites/hao')" mat-button mat-raised-button color="primary" class="mfg-button-fav">
                    <mat-icon class="start-outline" style="color: #ed8a19;font-size: 35px;margin-top: -15px;margin-left: -10px">star</mat-icon>
                </button>

                <button (click)="clickNavigation('/mfg')" mat-button mat-raised-button color="primary" class="mfg-button">
                    <mat-icon>key</mat-icon>
                    MFG
                </button>

                <!--<mat-form-field appearance="outline">
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput autocomplete="off">
                </mat-form-field>-->
            </div>
        </div>
    </div>

    <div fxLayout="row" *ngIf="loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>

    <table mat-table [dataSource]="dataSource" matSort matSortActive="id_hao" matSortDirection="desc" matSortDisableClear  class="mat-table cdk-table mat-elevation-z8">
        <ng-container matColumnDef="favorito">
            <th mat-header-cell  *matHeaderCellDef> <mat-icon style="color: #ed8a19">star</mat-icon> </th>
            <td mat-cell *matCellDef="let element">
                <mat-icon *ngIf="!element.favorito; else elseFav;"
                          (click)="addFavorito(element.codigo, element.pipeId); element.favorito = true;"
                          class="start-outline">star_outline</mat-icon>

                <ng-template #elseFav>
                    <mat-icon (click)="removeFavorito(element.codigo); element.favorito = false;"
                              class="start-outline" style="color: #ed8a19;">star_rate</mat-icon>
                </ng-template>
            </td>
        </ng-container>

        <ng-container matColumnDef="shared">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> <mat-icon style="color: #448aff">share</mat-icon> </th>
            <td mat-cell *matCellDef="let element">
                <mat-icon *ngIf="!element.shared; else elseShared;"
                          (click)="addShared(element.codigo, element.pipeId, element.consultor); element.shared = true;"
                          class="start-outline" style="color: #8c9194">share</mat-icon>

                <ng-template #elseShared>
                    <mat-icon (click)="removeShared(element.codigo); element.shared = false;"
                              class="start-outline" style="color: #448aff;">share</mat-icon>
                </ng-template>
            </td>
        </ng-container>

        <ng-container matColumnDef="codigo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Código <mat-icon style="font-size: 14px;" matTooltip="Registro de identificação interno por vaga" matTooltipPosition="above">info</mat-icon> </th>
            <td mat-cell *matCellDef="let element"> {{element.codigo}} </td>
        </ng-container>

        <ng-container matColumnDef="criado_em">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Criado em <mat-icon style="font-size: 14px;" matTooltip="Data na qual a oportunidade foi registrada" matTooltipPosition="above">info</mat-icon></th>
            <td mat-cell *matCellDef="let element"> {{element.criadoEm | date: 'dd/MM/yyyy' }} </td>
        </ng-container>

        <ng-container matColumnDef="atualizado_em">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Atualizado <mat-icon style="font-size: 14px;" matTooltip="Data na qual o relacionamento com a oportunidade foi atualizado." matTooltipPosition="above">info</mat-icon></th>
            <td mat-cell *matCellDef="let element"> {{element.atualizadoEm | date: 'dd/MM/yyyy' }} </td>
        </ng-container>

        <ng-container matColumnDef="consultor">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Consultor <mat-icon style="font-size: 14px;" matTooltip="Este é o seu ou sua Consultor(a) responsável pelo seu projeto aqui na Aprimorha. Fique a vontade para acessá-lo(a)!" matTooltipPosition="above">info</mat-icon></th>
            <td mat-cell *matCellDef="let element">{{ (!!element.consultor) ? element.consultor : ' - ' }}</td>
        </ng-container>

        <ng-container matColumnDef="empresa">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Empresa <mat-icon style="font-size: 14px;" matTooltip="Esta é a empresa na qual a oportunidade foi desenvolvida." matTooltipPosition="above">info</mat-icon></th>
            <td mat-cell *matCellDef="let element">{{ (!!element.empresa) ? element.empresa : ' - ' }}</td>
        </ng-container>

        <ng-container matColumnDef="conexao">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Conexão <mat-icon style="font-size: 14px;" matTooltip="Este é o LinkedIn do(a) Recrutador(a) ou HeadHunter responsável pela vaga." matTooltipPosition="above">info</mat-icon></th>
            <td mat-cell *matCellDef="let element">
                <a *ngIf="element.linkedin" target="_blank" [href]="sanitize(element.linkedin)"><img src="/assets/linkedin-in.png" width="25" height="25" style="position: relative; top: 7px" /></a>
                <img *ngIf="!element.linkedin" src="/assets/linkedin-out.png" width="25" height="25" style="position: relative; top: 7px" />
                {{ (!!element.conexao) ? element.conexao : ' - ' }}
            </td>
        </ng-container>

        <ng-container matColumnDef="descricao_vaga">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Descrição da vaga <mat-icon style="font-size: 14px;" matTooltip="Principais informações sobre a oportunidade trabalhada." matTooltipPosition="above">info</mat-icon></th>
            <td mat-cell *matCellDef="let element">{{ (!!element.descricaoVaga) ? element.descricaoVaga : ' - ' }}</td>
        </ng-container>

        <ng-container matColumnDef="ponto">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span style="display: block; width: auto; height: auto; margin-top: -6px;">
                    Ponto
                </span>
            </th>
            <td mat-cell *matCellDef="let element">{{ (element.ponto) ? element.ponto : ' - ' }}</td>
        </ng-container>

        <ng-container matColumnDef="observacao" stickyEnd>
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Observação
                <mat-icon
                        style="font-size: 14px;"
                        matTooltip="Etapa em que a vaga está evoluindo, podendo ser: Ponto A - O Recrutador ou HeadHunter demonstrou interesse pelo seu perfil e quer evoluir para uma conversa. Ponto B - Conversa com o Recrutador. Ponto C - Conversa com o gestor ou gestora responsável pelo reporte da vaga. Ponto D - Negociação de salário e data de início para a vaga."
                        matTooltipPosition="above"
                >
                    info
                </mat-icon>
            </th>
            <td mat-cell *matCellDef="let element">
                <mat-icon style="cursor: pointer;" *ngIf="!!element.observacao" [matMenuTriggerFor]="menu">search</mat-icon>
                <mat-menu #menu="matMenu" class="panel-mat-menu">
                    {{ element.observacao }}
                </mat-menu>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="11">Nenhum registro encontrado</td>
        </tr>
    </table>
    <div fxLayout="row" *ngIf="loading" style="margin-top: 0;">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>

    <mat-paginator
                   [disabled]="loading"
                   [pageSizeOptions]="pageRanger"
                   [length]="length"
                   [pageSize]="pageSize"
                   (page)="changePage($event)"></mat-paginator>

</app-container-transparent>
